import { gql } from '@apollo/client';

export const SEO_META_DATA = gql`
    query SeoByUrl($url: ID) {
        seoByUrl(url: $url) {
            title
            description
            header
            byline
        }
    }
`;
